import { API, axios, SendRequest} from '@/imports-files/pages/admins/dashboard/clients/integration';


export class showJob extends SendRequest 
{

  async getJobsData(params) 
  {
    const url = API.open.GET_CAREER_PAGE_DATA;
    try 
    {
      const result = await axios.post( url,
                                    params,
                                    this.setHeaderJSON(),
                                    this.setCrossDomainTrue(),
                                    this.setCredentialsJSON())
      return result;
    } 
    catch (error) 
    {
      return error;
    }

  }

  async getfilteredJobsData(params)
  {
    const url = params.isFrame ? API.open.SEND_IFRAME_SEARCH_DATA : API.open.SEND_CAREER_PAGE_SEARCH_DATA;
    try
    {
      const result = await axios.post( url,
                                    params,
                                    this.setHeaderJSON(),
                                    this.setCrossDomainTrue(),
                                    this.setCredentialsJSON())
      return result;
    }
    catch (error)
    {
      return error;
    }

  }

  async getCountries(params)
  {
    const url = `https://restcountries.eu/rest/v2/all?offset=${params.length}`;
    try 
    {
      const result = await axios.get( url,
                                    params,
                                    this.setHeaderJSON(),
                                    this.setCrossDomainTrue(),
                                    this.setCredentialsJSON())
      return result;
    } 
    catch (error) 
    {
      return error;
    }
  }
}